import React from 'react';

import { QueryBuilderStore } from 'controls/queryBuilder/queryBuilderStore';

// the parts of a builder can be shown on their own too, without one
export const QueryBuilderContext = React.createContext<QueryBuilderStore | null>(null);
